var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('div', [_vm._v("\n        Вы можете использовать данные оценки благонадежности физических лиц и\n        ИП внутри любой вашей учетной системы через интеграцию с Unirate API.\n        Такая интеграция существенно ускоряет бизнес-процессы, избавляет\n        пользователей от рутины, необходимости переключаться между окнами и\n        снижает риски ошибок связанных с человеческим фактором.\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_vm._v("\n        Например, вы можете внедрить автоматические проверки в следующих\n        сценариях:\n        "), _c('ul', [_c('li', [_vm._v("\n            Проверка кандидатов устраивающихся на материально-ответственные\n            должности или массовые профессии.\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Проверка Индивидуальных предпринимателей перед предоставлением\n            отсрочки платежа.\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_vm._v("Преимущества использования Unirate API:")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }],
    class: _vm.theme.integrationTableWrap
  }, [_c('table', {
    class: _vm.theme.integrationTable
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Повышение скорости принятия решения.")]), _vm._v(" "), _c('td', [_vm._v("\n                За счет интеграции проверки непосредственно в вашу учетную\n                систему.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Снижение финансовых рисков.")]), _vm._v(" "), _c('td', [_vm._v("\n                За счет снижения рисков человеческих ошибок и экономии на\n                разработке собственных сервисов.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Автоматизация проверки.")]), _vm._v(" "), _c('td', [_vm._v("\n                Проверка выполняется одной кнопкой или вообще без кнопки,\n                бесшовно встраиваясь в ваш рабочий процесс.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Быстрая проверка большого объема данных.")]), _vm._v(" "), _c('td', [_vm._v("\n                Больше не нужно вводить данные каждого кандидата в веб-форму.\n              ")])])])])]), _vm._v(" "), _c('img', {
    class: _vm.theme.integrationImage,
    attrs: {
      "src": require('./integration.png')
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_vm._v("\n        Unirate предоставляет API интерфейсы на базе RESTful и JSON. С их\n        помощью доступ функциям проверки ФЛ и ИП может получить любое\n        приложение без использования веб-интерфейса, что позволяет реализовать\n        процесс проверки внутри \"единого окна\".\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_vm._v("\n        Свяжитесь с нами, чтобы получить более подробную информацию о ценах и\n        вариантах использования Unirate API.\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.left",
      modifiers: {
        "left": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.requestIntegration
    }
  }, [_vm._v("\n          Оставить заявку\n        ")])], 1)])]), _vm._v(" "), _c('v-modal', {
    attrs: {
      "active": _vm.isShowConfirm
    },
    on: {
      "close": function($event) {
        _vm.isShowConfirm = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v(" Спасибо ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n          Ваша заявка принята\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_vm._v("\n          Мы свяжемся с вами в ближайшее время.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" Закрыть ")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fbcee2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/integration/Integration.vue
// module id = 1031
// module chunks = 0